import type { WindowDescriptor } from '@krp/client-runtime'
import type { ReceiptsUiState } from '../reducer'
import { cashierAccessWindows } from '../features/cashier-access/windows'
import { cashierAnalyticsWindows } from '../features/cashier-analytics/windows'
import { cashierGroupsWindows } from '../features/cashier-groups/windows'
import { salesPointsWindows } from '../features/sales-points/windows'
import { ownJournalWindows } from '../features/own-journal/windows'
import { ownCashiersWindows } from '../features/own-cashiers/windows'

/** Окна пакета — по сущностям; адреса и ключи окон каждой сущности объявлены в её `windows.ts`. */
export const receiptsWindows: readonly WindowDescriptor<ReceiptsUiState>[] = [
  ...ownJournalWindows, ...ownCashiersWindows, ...cashierAnalyticsWindows, ...cashierGroupsWindows, ...cashierAccessWindows, ...salesPointsWindows,
]
